import "./vendor/jquery-ui/jquery-ui.js";
import "./vendor/jquery.joyride-2.1.js";
import "./vendor/jquery.cookie/jquery.cookie.js";
import "./AccessibleTooltip.js";
import "./vendor/focus-visible/dist/focus-visible.js";
import "./hitta.js";
import "./typescript/Vgr.Util";
import "./typescript/Vgr.Ui";
import "./SearchQueryCooki.js";
import "./piwik.analytics";

import * as $ from "jquery";
window.$ = $;
